import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const THRESHOLD = 400;

export default function BackToTop({ collapsed }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > THRESHOLD);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  const left = collapsed ? "left-4 lg:left-[5rem]" : "left-4 lg:left-[17rem]";

  return (
    <button
      type="button"
      aria-label="Back to top"
      title="Back to top"
      onClick={() => window.scrollTo({ top: 0 })}
      className={`fixed bottom-6 ${left} z-40 flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 shadow-md transition-colors hover:bg-gray-50 hover:text-gray-900`}
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}
